import { Injectable } from '@angular/core';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { UserFilter } from '@app/pcs/models';
import { getDeadlineSuffix, getFilterName, getTtpId, getValidTo, isDeadlineFilter } from '@app/pcs/util/user-filter';
import { formatDateArray, FULL_DATE_TIME_FORMAT } from '@util/date-util';
import * as R from 'ramda';

@Injectable()
export class FilterService {

  constructor(private translateService: PcsTranslateService) {
  }

  getFilterName(filter: UserFilter): string {
    const deadlineFilter = isDeadlineFilter(filter);
    return deadlineFilter ? this.transformDeadlineFilterName(filter) : this.transformFilterName(filter);
  }

  private transformFilterName(filter: UserFilter) {
    return this.translateService.translate(getFilterName(filter), [getTtpId(filter)]);
  }

  private transformDeadlineFilterName(filter: UserFilter) {
    const deadlineValidTo: string = formatDateArray(getValidTo(filter), FULL_DATE_TIME_FORMAT);
    return this.translateService.translate('dashboard.filters.deadline', [
      deadlineValidTo,
      this.getDeadlineSuffix(filter),
      R.join(', ', this.getProcessTypes(filter))
    ]);
  }

  private getProcessTypes(userFilter: UserFilter) {
    const processTypes = userFilter.filter.dossierSearchModel.processTypes;
    return R.map(processType => this.translateService.translate(processType.description), processTypes);
  }

  private getDeadlineSuffix(filter: UserFilter) {
    const deadlineSuffix = getDeadlineSuffix(filter);
    return deadlineSuffix ? this.translateService.translate(deadlineSuffix, [getTtpId(filter)]) : '';
  }

}
